"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEvents = void 0;
var UserEvents;
(function (UserEvents) {
    UserEvents["USER_ACCOUNT_CREATED"] = "user_account_created";
    UserEvents["ACCOUNT_CREATED"] = "account_created";
    UserEvents["NEW_ACCOUNT_STATE"] = "new_account_state";
    UserEvents["LOGIN_PASSWORD_SUCCESS"] = "login_password_success";
    UserEvents["LOGIN_OTP_SUCCESS"] = "login_otp_success";
    UserEvents["LOGIN_2FA_SUCCESS"] = "login_2fa_success";
    UserEvents["LOGIN_TOKEN_SUCCESS"] = "login_token_success";
    UserEvents["SET_PASSWORD_SUCCESS"] = "set_password_success";
    UserEvents["REQUEST_PASSWORD_RESET"] = "request_password_reset";
    UserEvents["LOGOUT"] = "logout";
    UserEvents["LOGIN_PASSWORD_FAIL"] = "login_password_fail";
    UserEvents["LOGIN_OTP_FAIL"] = "login_otp_fail";
    UserEvents["LOGIN_TOKEN_FAIL"] = "login_otp_fail";
    UserEvents["SET_PASSWORD_FAIL"] = "set_password_fail";
    UserEvents["ONBOARDING_NAV"] = "onboarding_nav";
    UserEvents["ONBOARDING_UPLOAD"] = "onboarding_upload";
    UserEvents["ONBOARDING_UPLOAD_DELETE"] = "onboarding_upload_delete";
    UserEvents["ONBOARDING_COMPLETED"] = "onboarding_completed";
    UserEvents["DOCUSIGN_STARTED"] = "docusign_started";
    UserEvents["DOCUSIGN_COMPLETED"] = "docusign_completed";
    UserEvents["DOCUSIGN_NOT_COMPLETED"] = "docusign_not_completed";
    UserEvents["EMAIL_DOCUMENTS"] = "email_documents";
    UserEvents["EMAIL_INVITE"] = "email_invite";
    UserEvents["EMAIL_UGMA_INVITE"] = "email_ugma_invite";
    UserEvents["EMAIL_RESET_PASSWORD"] = "email_reset_password";
    UserEvents["KYC_START"] = "kyc_start";
    UserEvents["KYC_CANCEL"] = "kyc_cancel";
    UserEvents["KYC_END"] = "kyc_end";
    UserEvents["IAV_START"] = "iav_start";
    UserEvents["IAV_END"] = "iav_end";
    UserEvents["IAV_CANCEL"] = "iav_cancel";
    UserEvents["CORPORATE_EVENT"] = "corporate_event";
})(UserEvents || (exports.UserEvents = UserEvents = {}));
//# sourceMappingURL=events.js.map